export function normalizeQueryParam(value: string | string[] | null | undefined): string | undefined {
    if (Array.isArray(value)) {
        return value[0] || undefined;
    }
    return value || undefined;
}

export function getUtmTermFromUrl(url: string): string | undefined {
    const queryIndex = url.indexOf('?');
    if (queryIndex === -1) {
        return undefined;
    }

    return normalizeQueryParam(new URLSearchParams(url.slice(queryIndex + 1)).get('utm_term') ?? undefined);
}

export function resolveUtmTerm(utmTerm: string | string[] | null | undefined, url?: string): string | undefined {
    return normalizeQueryParam(utmTerm) ?? (url ? getUtmTermFromUrl(url) : undefined);
}
